require('../../modules/es6.number.is-nan');
module.exports = require('../../modules/_core').Number.isNaN;


//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/fn/number/is-nan.js
// module id = 735
// module chunks = 0